import { BaseApi } from './base.api.js';

export class CompanyApi extends BaseApi {
    constructor(client) {
        super(client, '/company');
    }
}
